import { render, staticRenderFns } from "./app-bar.app.vue?vue&type=template&id=70a899aa&scoped=true"
import script from "./app-bar.app.vue?vue&type=script&lang=ts"
export * from "./app-bar.app.vue?vue&type=script&lang=ts"
import style0 from "./app-bar.app.vue?vue&type=style&index=0&id=70a899aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a899aa",
  null
  
)

export default component.exports